import React, { useState, useEffect } from 'react';

const edgyQuotes = [
  "My anxiety has anxiety about anxiety",
  "i'm like this blunt…falling apart but still lit",
  "sometimes when i'm reaping i'm like damn wtf did i sow",
  "Being a loser who stays home is so cool guys",
  "Me driving at night: I hope this is the road",
  "It's getting colder, who wants to start a fire and throw me in it",
  "i wanna get drunk and cry.",
  "What if I came to your house and died",
  "Wipes tears Hits Blunt Looks at the mirror Gang gang",
  "sorry if i'm acting weird, im not comfortable being human",
  "my application was 🎉✨APPROVED!✨🎉 I am being euthanized",
  "Y'all be havin ㊙️🈲㊗️ on your back, whole time it say hibachi benihana teriyaki",
  "U either gon BE MY ROCK or get HIT wit one BITCH",
  "just asked myself if i'm crazy we said no",
  "A hoe final form is OVERLY religious",
  "u gotta catch a girl red handed or she taking that lie to the grave",
  "Don't leave your phone open around me. I'll delete your TikTok.",
  "Some days I look for love, other days I look for a freakiest freak that ever frook",
  "I'll hold a woodpecker to a btch head",
  "Are you sad? Sad is your mom because she's not my mother-in-law",
  "you call it ghosting, i call it saving you from me",
  "Look at your booty, do u deserve a gift on Valentines Day?",
  "February 14 Imma be throwing large rocks at couples",
  "Just cut off a student driver. Welcome to the real world bitch",
  "Bitches be like I'm done fucking wit you, bitch shut up an open the door",
  "U can't even choke a btch out nowadays",
  "mfs get wet & start smiling",
  "I'm a lil fucked up in the head, that's why I stay to myself"
];

const BrandFrog = () => {
  const [eyePosition, setEyePosition] = useState({ x: 0, y: 0 });
  const [isBlinking, setIsBlinking] = useState(false);
  const [currentQuote, setCurrentQuote] = useState('');
  const [isQuoteFading, setIsQuoteFading] = useState(false);

  const changeQuote = () => {
    setIsQuoteFading(true);
    setTimeout(() => {
      const newQuote = edgyQuotes[Math.floor(Math.random() * edgyQuotes.length)];
      setCurrentQuote(newQuote);
      setIsQuoteFading(false);
    }, 1000); // Wait for fade out before changing quote
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      const rect = document.getElementById('frogSvg').getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      
      // Calculate angle between mouse and center
      const angle = Math.atan2(e.clientY - centerY, e.clientX - centerX);
      
      // Max eye movement radius is 4 units
      const eyeX = Math.cos(angle) * 4;
      const eyeY = Math.sin(angle) * 4;
      
      setEyePosition({ x: eyeX, y: eyeY });
    };

    // Random blinking
    const blinkInterval = setInterval(() => {
      setIsBlinking(true);
      setTimeout(() => setIsBlinking(false), 150);
    }, Math.random() * 3000 + 2000);

    // Initial quote
    setCurrentQuote(edgyQuotes[Math.floor(Math.random() * edgyQuotes.length)]);

    // Quote change interval
    const quoteInterval = setInterval(changeQuote, 5000);

    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      clearInterval(blinkInterval);
      clearInterval(quoteInterval);
    };
  }, []);

  return (
    <div className="relative w-96 mx-auto">
      {/* Frog SVG */}
      <svg id="frogSvg" viewBox="0 0 200 200" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        {/* Body */}
        <path 
          d="M100 40C60 40 30 70 30 120C30 170 60 190 100 190C140 190 170 170 170 120C170 70 140 40 100 40Z" 
          fill="#22C55E"
          className="animate-subtle-bounce"
        />

        {/* Simple spots */}
        <circle cx="70" cy="100" r="6" fill="#16A34A" opacity="0.6"/>
        <circle cx="130" cy="100" r="6" fill="#16A34A" opacity="0.6"/>
        <circle cx="85" cy="140" r="5" fill="#16A34A" opacity="0.6"/>
        <circle cx="115" cy="140" r="5" fill="#16A34A" opacity="0.6"/>

        {/* Left Eye */}
        <g>
          <circle cx="80" cy="70" r="15" fill="white"/>
          <circle 
            cx={80 + eyePosition.x} 
            cy={70 + eyePosition.y} 
            r="7" 
            fill="black"
            style={{ transform: isBlinking ? 'scaleY(0.1)' : 'scaleY(1)', transformOrigin: 'center' }}
          />
        </g>

        {/* Right Eye */}
        <g>
          <circle cx="120" cy="70" r="15" fill="white"/>
          <circle 
            cx={120 + eyePosition.x} 
            cy={70 + eyePosition.y} 
            r="7" 
            fill="black"
            style={{ transform: isBlinking ? 'scaleY(0.1)' : 'scaleY(1)', transformOrigin: 'center' }}
          />
        </g>

        {/* Happy Smile - moved down */}
        <path 
          d="M75 100C75 100 85 110 100 110C115 110 125 100 125 100" 
          stroke="#1a4a2e" 
          strokeWidth="4" 
          strokeLinecap="round"
          fill="none"
        />
      </svg>

      {/* Quote Display */}
      <div className="absolute -bottom-24 left-1/2 transform -translate-x-1/2 w-full text-center">
        <p 
          className={`text-green-400 font-bold text-lg transition-opacity duration-1000 ${
            isQuoteFading ? 'opacity-0' : 'opacity-100'
          }`}
        >
          {currentQuote}
        </p>
      </div>
    </div>
  );
};

export default BrandFrog; 